import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { AuthGuard } from './auth.guard';
import { LoginComponent } from './components/login/login.component';
import { UsuariosComponent } from './components/dashboard/componts/usuarios/usuarios.component';
import { CoursesComponent } from './components/dashboard/componts/courses/courses.component';
import { PartnersComponent } from './components/dashboard/componts/partners/partners.component';
import { SinapiComponent } from './components/dashboard/componts/sinapi/sinapi.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'licita/users',
        pathMatch: 'full'
    },
    {
        path: '',
        component: AppLayoutComponent,
        children: [
            {
                path: 'licita/users',
                loadChildren: () => import('./components/dashboard/componts/usuarios/usuarios.module').then(m => m.UsuariosModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'licita/courses',
                loadChildren: () => import('./components/dashboard/componts/courses/courses.module').then(m => m.CoursesModule),
                component:CoursesComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'licita/partners',
                loadChildren: () => import('./components/dashboard/componts/partners/partners.module').then(m => m.PartnersModule),
                component:PartnersComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'licita/sinapi',
                loadChildren: () => import('./components/dashboard/componts/sinapi/sinapi.module').then(m => m.SinapiModule),
                component:SinapiComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'licita/faker-users',
                loadChildren: () => import('./components/dashboard/componts/faker-users/faker-users.module').then(m => m.FakerUsersModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'licita/help',
                loadChildren: () => import('./components/dashboard/componts/help/help.module').then(m => m.HelpModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'licita/support-chat',
                loadChildren: () => import('./components/dashboard/componts/support-chat/support-chat.module').then(m => m.SupportChatModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'licita/audit',
                loadChildren: () => import('./components/dashboard/componts/audit/audit.module').then(m => m.AuditModule),
                canActivate: [AuthGuard],
                data: { allowedRoles: ['Manager', 'Owner', 'SuperUser'] }
            }
        ]
    },
    {
        path: '',
        component: AppLayoutComponent,
        children: [
            {
                path: 'licita/solicitantes',
                loadChildren: () => import('./components/solicitantes/solicitantes.module').then(m => m.UsuariosModule),
                canActivate: [AuthGuard],
            },
        ]
    },
    { 
        path: 'login', 
        loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule),
        canActivate: [AuthGuard], // Adicionando o AuthGuard na rota de login
        data: { isLoginPage: true } // Adicionando um flag para identificar a rota de login
    },
    { path: 'notfound', component: NotfoundComponent },
    { path: '**', redirectTo: '/notfound' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
            useHash: false
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}